export const formatPromotionChartData = (bookedBookings, cancelledBookings) => {
  const bookedPromotions = bookedBookings.reduce((acc, booking) => {
    booking.rooms.forEach((room) => {
      const fromdate = booking.fromdate;
      const promotionData =
        room.promotionsApplied && room.promotionsApplied[fromdate];
      const promotionName = promotionData
        ? promotionData.promotionName
        : "None";
      acc[promotionName] = (acc[promotionName] || 0) + 1;
    });
    return acc;
  }, {});
  const cancelledPromotions = cancelledBookings.reduce((acc, booking) => {
    booking.rooms.forEach((room) => {
      const fromdate = booking.fromdate;
      const promotionData =
        room.promotionsApplied && room.promotionsApplied[fromdate];
      const promotionName = promotionData
        ? promotionData.promotionName
        : "None";
      acc[promotionName] = (acc[promotionName] || 0) + 1;
    });
    return acc;
  }, {});

  const allPromotions = [
    ...new Set([
      ...Object.keys(bookedPromotions),
      ...Object.keys(cancelledPromotions),
    ]),
  ];
  const sortedPromotions = allPromotions.sort((a, b) => {
    const totalA = (bookedPromotions[a] || 0) + (cancelledPromotions[a] || 0);
    const totalB = (bookedPromotions[b] || 0) + (cancelledPromotions[b] || 0);
    return totalB - totalA;
  });

  const bookedData = sortedPromotions.map(
    (promotion) => bookedPromotions[promotion] || 0
  );
  const cancelledData = sortedPromotions.map(
    (promotion) => cancelledPromotions[promotion] || 0
  );

  return {
    labels: sortedPromotions,
    datasets: [
      {
        label: "Booked",
        data: bookedData,
        backgroundColor: "rgba(0, 128, 128, 0.6)",
        borderColor: "rgba(0, 128, 128, 1)",
        borderWidth: 1,
      },
      {
        label: "Cancelled",
        data: cancelledData,
        backgroundColor: "rgba(0, 102, 204, 0.6)",
        borderColor: "rgba(0, 102, 204, 1)",
        borderWidth: 1,
      },
    ],
  };
};
